module.exports = __webpack_public_path__ + "static/media/GM-Light.8a058d20.webp";